/**
 * Call a function on each value in an object
 */
export default function objectForEach<T>(o: { [key: string]: T }, f: (t: T, key: string) => void) {
  for (const key in o) {
    f(o[key], key);
  }
}
